// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/iconfont/iconfont.css'
import '@/assets/css/reset.css'
import store from '@/store'
import config from '@/api/config'
import './utils/rem'
import * as filters from '@/utils/filters'
import tools from '@/utils/tools'
import './assets/iconfont/iconfont.css'
// 图片预览插件
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import toast from '@/components/toast'
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})

Vue.config.productionTip = false
Vue.prototype.$config=config
Vue.prototype.$tools=tools
Vue.prototype.$eventBus = new Vue({})
/* eslint-disable no-new */
Vue.use(ElementUI)
Vue.use(toast)
// 注册过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})
export default function(context, inject) {
  inject('tools', tools)
  inject('config', config)
}

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js